/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import Training from "./Training";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import Pagination from "react-js-pagination";
import { Trans } from "react-i18next";
import i18next from "i18next";
import Helpers from "util/helpers";

class Trainings extends Component {
  state = {
    filteredTrainingData: [],
    filterTerm: "",
    activePage: 1,
    sort_by: "trStartDate",
    sort_dir: "desc",
  };

  settings = {
    itemsPerPage: 10,
  };

  componentDidMount() {
    this.setState({ filteredTrainingData: this.props.data });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data) {
      this.setState({ filteredTrainingData: this.props.data, activePage: 1 });
    }

    //Training name bilgisine göre filtreler
    if (this.state.filterTerm !== prevState.filterTerm) {
      this.setState({
        filteredTrainingData: this.props.data.filter((item) => {
          return Helpers.getTurkishCharaterFixedList(
            item.training.name ?? ""
          ).includes(
            Helpers.getTurkishCharaterFixedList(this.state.filterTerm)
          );
        }),
      });
    }
  }

  handlePageChange = (pageNum) => {
    this.setState({ activePage: pageNum });
  };

  handleFilter = (e) => {
    this.setState({
      filterTerm: e.target.value,
      activePage: 1,
    });
  };

  renderSearchBar = () => {
    return (
      <div className="col-xs-12 col-sm-12 col-md-3 col-lg-4 tableSearchArea">
        <div className="inner-addon right-addon">
          <span className="iconmford fo-icon-search"></span>
          <input
            type="text"
            name="tableSearch"
            id="tableSearch"
            className="form-control"
            placeholder={i18next.t("10053")}
            onChange={(e) => this.handleFilter(e)}
            value={this.state.filterTerm}
          />
        </div>
      </div>
    );
  };

  renderHeaderToolbar = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginRight: "10px",
        }}
      >
        {this.renderSearchBar()}

        <Pagination
          hideFirstLastPages={true}
          prevPageText={i18next.t(10110)}
          nextPageText={i18next.t(10111)}
          hideDisabled={true}
          hideNavigation={true}
          activePage={this.state.activePage}
          itemsCountPerPage={this.settings.itemsPerPage}
          totalItemsCount={
            this.state.filteredTrainingData?.length > 0
              ? this.state.filteredTrainingData.length
              : 0
          }
          onChange={(e) => this.handlePageChange(e)}
          itemClass="page-item"
          linkClass="page-link"
        />
      </div>
    );
  };

  renderFooterToolbar = () => {
    return (
      <div className="table-footer-toolbar">
        {/* <button className="export-button" onClick={this.handleExportCSV}>
          <Trans desc="Dışa Aktar">10113</Trans>
        </button> */}
      </div>
    );
  };

  trType = "";
  trName = "";
  trLocation = "";
  trDuration = "";
  trStatus = "";
  trSuccess = "";
  trStartDate = "";
  trEndDate = "";

  reOrder = (orderBy) => {
    let sort_dir = "asc";
    if (this.state.sort_dir === "asc") sort_dir = "desc";
    this.setState({
      sort_by: orderBy,
      sort_dir: sort_dir,
    });
  };

  setSotingClassNames = () => {
    this.trType = "";
    this.trName = "";
    this.trLocation = "";
    this.trDuration = "";
    this.trStatus = "";
    this.trSuccess = "";
    this.trStartDate = "";
    this.trEndDate = "";
    switch (this.state.sort_by) {
      case "trType":
        this.trType = `_${this.state.sort_dir}`;
        break;
      case "trName":
        this.trName = `_${this.state.sort_dir}`;
        break;
      case "trLocation":
        this.trLocation = `_${this.state.sort_dir}`;
        break;
      case "trDuration":
        this.trDuration = `_${this.state.sort_dir}`;
        break;
      case "trStatus":
        this.trStatus = `_${this.state.sort_dir}`;
        break;
      case "trSuccess":
        this.trSuccess = `_${this.state.sort_dir}`;
        break;
      case "trStartDate":
        this.trStartDate = `_${this.state.sort_dir}`;
        break;
      case "trEndDate":
        this.trEndDate = `_${this.state.sort_dir}`;
        break;
      default:
        this.trName = `_${this.state.sort_dir}`;
        break;
    }
  };

  renderData = (start, end) => {
    const sorted = this.state.filteredTrainingData.sort((a, b) => {
      switch (this.state.sort_by) {
        case "trName":
          return this.state.sort_dir === "desc"
            ? a.training.name.localeCompare(b.training.name)
            : b.training.name.localeCompare(a.training.name);
        case "trLocation":
          return this.state.sort_dir === "desc"
            ? (a.trainingLocation ?? "").localeCompare(b.trainingLocation ?? "")
            : (b.trainingLocation ?? "").localeCompare(
              a.trainingLocation ?? ""
            );
        case "trDuration":
          return this.state.sort_dir === "desc"
            ? (a.timeplans !== null ? a.timeplans[0]?.duration : 0) -
            (b.timeplans !== null ? b.timeplans[0]?.duration : 0)
            : (b.timeplans !== null ? b.timeplans[0]?.duration : 0) -
            (a.timeplans !== null ? a.timeplans[0]?.duration : 0);
        case "trStatus":
          return this.state.sort_dir === "desc"
            ? a.score - b.score
            : b.score - a.score;
        case "trSuccess":
          return this.state.sort_dir === "desc"
            ? a.successful - b.successful
            : b.successful - a.successful;
        case "trStartDate":
          return this.state.sort_dir === "desc"
            ? new Date(
              a.timeplans !== null ? a.timeplans[0]?.startDate ?? 0 : 0
            ) -
            new Date(
              b.timeplans !== null ? b.timeplans[0]?.startDate ?? 0 : 0
            )
            : new Date(
              b.timeplans !== null ? b.timeplans[0]?.startDate ?? 0 : 0
            ) -
            new Date(
              a.timeplans !== null ? a.timeplans[0]?.startDate ?? 0 : 0
            );
        case "trEndDate":
          return this.state.sort_dir === "desc"
            ? new Date(
              a.timeplans !== null ? a.timeplans[0]?.endDate ?? 0 : 0
            ) -
            new Date(
              b.timeplans !== null ? b.timeplans[0]?.endDate ?? 0 : 0
            )
            : new Date(
              b.timeplans !== null ? b.timeplans[0]?.endDate ?? 0 : 0
            ) -
            new Date(
              a.timeplans !== null ? a.timeplans[0]?.endDate ?? 0 : 0
            );
        case "trType":
          return this.state.sort_dir === "desc"
            ? a.trainingMethod.label.localeCompare(b.trainingMethod.label)
            : b.trainingMethod.label.localeCompare(a.trainingMethod.label);
        default:
          return this.state.sort_dir === "desc"
            ? a.training.name.localeCompare(b.training.name)
            : b.training.name.localeCompare(a.training.name);
      }
    });

    return sorted.slice(start, end).map((t) => {
      return (
        <Training
          key={t.key}
          t={t}
          employeeCode={this.props.employeeCode}
          billable={this.props.billable}
          refresh={this.props.refresh}
        />
      );
    });
  };

  render() {
    let start = this.settings.itemsPerPage * (this.state.activePage - 1);
    let end = start + this.settings.itemsPerPage;

    this.setSotingClassNames();
    return (
      <>
        {this.props.spinner}
        <div>{this.renderHeaderToolbar()}</div>
        <div
          className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
          id="egitimKatalogu"
          style={{ display: "block" }}
        >
          <table
            className="table display responsive tgE dataTable no-footer dtr-none collapsed"
            id="dataTablePersonel"
          >
            <thead>
              <tr>
                <th
                  onClick={() => this.reOrder("trType")}
                  className={`all sorting${this.trType}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Tür">10014</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("trName")}
                  className={`all sorting${this.trName}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Eğitim Adı">10015</Trans>
                  </div>
                </th>
                <DesktopBreakpoint>
                  <th
                    onClick={() => this.reOrder("trLocation")}
                    className={`desktop sorting${this.trLocation}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Yer">10016</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trDuration")}
                    className={`desktop sorting${this.trDuration}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Süre">10017</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trStatus")}
                    className={`desktop sorting${this.trStatus}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Durum">10018</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trStartDate")}
                    className={`desktop sorting${this.trStartDate}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Başlangıç">10020</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trEndDate")}
                    className={`desktop sorting${this.trEndDate}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Bitiş">10021</Trans>
                    </div>
                  </th>
                  <th className="desktop">
                    <div className="tableTitle"></div>
                  </th>
                  <th className="none"></th>
                </DesktopBreakpoint>
              </tr>
            </thead>
            <tbody>{this.renderData(start, end)}</tbody>
          </table>
        </div>
      </>
    );
  }
}

const mapStateToProps = ({ application }) => {
  return {
    application,
  };
};

export default connect(
  mapStateToProps,
  {}
)(containsLongRunningProcess(requireAuth(Trainings)));
